import { BASE_ELEMENT_IDS as BASE_ELEMENT_IDS } from "../BaseDOM";
import MobileDOM, { ELEMENT_IDS } from "./MobileDOM";
import { ACTION_EVENTS } from "../UserAction";
import MobileUIController, {
	visibleElements,
	visibleInfopages,
} from "./MobileUIController";
import AbstractStates from "../../states/AbstractStates";
import { FETCH_TYPES } from "../../connect/Connect";
import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import CommanderBase from "../../commander/CommanderBase";
import SystemConfig, { CONFIG_PARAMS, MODES } from "../../system/SystemConfig";
import SystemPlatform from "../../system/SystemPlatform";
import IUIActions from "../IUIActions";
import IGame from "../../game/IGame";
import PlayerOptions from "../../player/PlayerOptions";
import events from "../../events/EventsObservable";
import { mobileAndTabletCheck } from "../../device/device";

@injectable()
export default class MobileUIStates extends AbstractStates {
	protected dom: MobileDOM;
	protected game: IGame;
	protected uiController: MobileUIController;
	protected uiActions: IUIActions;
	protected commander: CommanderBase;
	protected platform: SystemPlatform;
	protected config: SystemConfig;
	protected playerOptions: PlayerOptions;

	protected forcespinTimeout: any;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.DOM) dom: MobileDOM,
		@inject(SERVICE_IDENTIFIER.Game) game: IGame,
		@inject(SERVICE_IDENTIFIER.UIController) uiController: MobileUIController,
		@inject(SERVICE_IDENTIFIER.UIActions) uiActions: IUIActions,
		@inject(SERVICE_IDENTIFIER.Commander) commander: CommanderBase,
		@inject(SERVICE_IDENTIFIER.PlayerOptions) playerOptions: PlayerOptions
	) {
		super();

		this.dom = dom;
		this.game = game;
		this.uiController = uiController;
		this.uiActions = uiActions;
		this.commander = commander;
		this.platform = config.platform;
		this.config = config;
		this.playerOptions = playerOptions;
	}

	beforeSetState() {
		clearTimeout(this.forcespinTimeout);
		this.dom.onSetState();
	}

	stateInit() {
		document.getElementById("container").classList.add("state-init");

		this._visibleAllButtons(false);
		visibleBar(false);
		visibleInfopages(false);
	}

	stateLoaded() {
		document.getElementById("container").classList.remove("state-init");
		this.uiController.visibleButtons(false);
	}

	statePreinfo() {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_PREINFO_CLOSE,
			ACTION_EVENTS.ACTION_RESPONSIBLE_GAMING,
		]);

		let preinfoBtn = document.getElementById(
			BASE_ELEMENT_IDS.BUTTON_PREINFO_CLOSE
		);

		$(preinfoBtn).data("action", ACTION_EVENTS.ACTION_PREINFO_CLOSE);
		$(preinfoBtn).show();

		visibleBar(false);
	}

	stateSound(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowAction(ACTION_EVENTS.ACTION_SOUND_CHOOSE);

		let preinfoBtn = document.getElementById(
			BASE_ELEMENT_IDS.BUTTON_PREINFO_CLOSE
		);

		this.dom.soundChooseMessage.openMessage();

		if (this.commander.preinfo) {
			$(preinfoBtn).hide();
			visibleBar(false);
		} else {
			visibleBar(true);
		}
	}

	stateReady() {
		if (this.dom.soundChooseMessage.isMessageOpened()) {
			this.dom.soundChooseMessage.closeMessage();
		}
	}

	stateIdle(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowAllActions(true);

		visibleBar(true);

		$(document.getElementById(BASE_ELEMENT_IDS.BUTTON_PREINFO_CLOSE)).hide();

		this._visibleAllButtons(true);

		if (!this.platform.isVLT()) {
			visibleInfopages(false);
		}

		$("#" + ELEMENT_IDS.MENU_BURGER).hide();
		$("#" + ELEMENT_IDS.MENU_BURGER).css("opacity", 0);

		$("#" + ELEMENT_IDS.MENU_BET).hide();
		$("#" + ELEMENT_IDS.MENU_BET).css("opacity", 0);

		$("#" + ELEMENT_IDS.MENU_AUTOSTART).hide();
		$("#" + ELEMENT_IDS.MENU_AUTOSTART).css("opacity", 0);

		if (this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
			$("#" + ELEMENT_IDS.BUTTON_AUTOSTART_OPEN).hide();
			$("#" + ELEMENT_IDS.BUTTON_BET_OPEN).hide();
		}

		$("#" + ELEMENT_IDS.BUTTON_BURGER).data(
			"action",
			ACTION_EVENTS.ACTION_BURGER_OPEN
		);

		this.showAutostart();

		if (this.dom.freeSpinsShown) {
			$("#" + ELEMENT_IDS.BUTTON_BET_OPEN).hide();
		}

		let shield = document.getElementById(
			BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING
		);
		$([shield]).prop("disabled", false);
	}

	stateFsIdle(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_SPIN,
			ACTION_EVENTS.ACTION_AUTOSTART_CONTINUE,
			ACTION_EVENTS.ACTION_AUTOSTART_OPEN,
			ACTION_EVENTS.ACTION_AUTOSTART_CHOOSE,
			ACTION_EVENTS.ACTION_AUTOSTART_CLOSE,
			ACTION_EVENTS.ACTION_AUTOSTART_STOP,
		]);

		this._visibleAllButtons(false);
		$("#" + ELEMENT_IDS.BUTTON_SPIN_WRAP).show();

		this.showAutostart();
		$("#" + ELEMENT_IDS.BUTTON_AUTOSTART_OPEN).show();

		this.dom.showSpinBtn(BASE_ELEMENT_IDS.BUTTON_SPIN);

		let shield = document.getElementById(
			BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING
		);
		$([shield]).prop("disabled", false);
	}

	stateSpin() {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_AUTOSTART_STOP,
			ACTION_EVENTS.ACTION_FORCESTOP,
			ACTION_EVENTS.ACTION_SKIP,
		]);

		let autostart = this.game.autostart?.isAutostart();
		this.dom.showSpinBtn(
			autostart
				? BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART
				: BASE_ELEMENT_IDS.BUTTON_STOP
		);

		this._visibleAllButtons(false);
		$("#" + ELEMENT_IDS.BUTTON_SPIN_WRAP).show();

		let shield = document.getElementById(
			BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING
		);
		$([shield]).prop("disabled", true);
	}

	stateSkip() {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_SKIP,
			ACTION_EVENTS.ACTION_AUTOSTART_STOP,
		]);

		$("#" + ELEMENT_IDS.BUTTON_SPIN_WRAP).show();

		let autostart = this.game.autostart?.isAutostart();
		this.dom.showSpinBtn(
			autostart
				? BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART
				: BASE_ELEMENT_IDS.BUTTON_SKIP
		);
	}

	stateBonus() {
		this._visibleAllButtons(false);
		$("#" + ELEMENT_IDS.BUTTON_SPIN_WRAP).hide();
	}

	stateBonusWin() {
		this.stateBonus();
	}

	stateBonusWheel(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([ACTION_EVENTS.ACTION_BONUS_WHEEL_STOP]);

		$("#" + ELEMENT_IDS.BUTTON_SPIN_WRAP).show();
		$(`#${BASE_ELEMENT_IDS.BUTTON_STOP_BONUS_WHEEL}`).prop("disabled", true);
		this.dom.showSpinBtn(BASE_ELEMENT_IDS.BUTTON_STOP_BONUS_WHEEL);
	}

	stateForcespin() {
		// Default FORCESPIN delay is 200ms, overriden by behavior..buttonBuffer if set
		let delay = 200;
		if (this.config.get(CONFIG_PARAMS.BEHAVIOR)?.reel?.spin?.buttonBuffer) {
			delay =
				this.config.get(CONFIG_PARAMS.BEHAVIOR).reel.spin.buttonBuffer * 1000;
		}

		this.forcespinTimeout = setTimeout(() => {
			this.uiActions.unsetAllowedActions();
			this.uiActions.allowActions([
				ACTION_EVENTS.ACTION_SPIN,
				ACTION_EVENTS.ACTION_AUTOSTART_STOP,
			]);

			let autostart = this.game.autostart?.isAutostart();
			this.dom.showSpinBtn(
				autostart
					? BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART
					: BASE_ELEMENT_IDS.BUTTON_SPIN
			);

			$("#" + ELEMENT_IDS.BUTTON_SPIN_WRAP).show();
		}, delay);
	}

	stateSearching(data) {
		this.uiActions.unsetAllowedActions();
		this.uiActions.allowActions([
			ACTION_EVENTS.ACTION_AUTOSTART_STOP,
			ACTION_EVENTS.ACTION_FORCESTOP,
		]);
	}

	_visibleAllButtons(visible = true, except = []) {
		visibleElements(this.uiController.buttons, visible, except);
		this.uiController.visibleFSButton(visible);
	}

	stateError(error) {
		this.uiActions.unsetAllowedActions();
		this._visibleAllButtons(false);
		$("#" + ELEMENT_IDS.BUTTON_BURGER).show();

		if (error && error.fetchType === FETCH_TYPES.INIT) {
			$("#" + ELEMENT_IDS.BUTTON_BURGER).hide();
		}
	}

	stateJokerBonusWin(data: any) {
		this.uiActions.unsetAllowedActions();
		this._visibleAllButtons(false);
	}

	showAutostart() {
		let autostart = this.game.autostart?.isAutostart();
		this.dom.showSpinBtn(
			autostart
				? BASE_ELEMENT_IDS.BUTTON_SPIN_AUTOSTART
				: BASE_ELEMENT_IDS.BUTTON_SPIN
		);
		let autostartContinue = $("#" + ELEMENT_IDS.BUTTON_AUTOSTART_CONTINUE);
		if (this.game.autostart?.isPaused()) {
			let n = this.game.autostart?.getLastAutostart();
			autostartContinue.text(n === Infinity ? "" : n);
			autostartContinue.show();
		} else {
			autostartContinue.hide();
		}
	}
}

function visibleBar(visible = true) {
	visible ? $("#mxBar").show() : $("#mxBar").hide();
}
